// Dependencies
import styled from 'styled-components';

const colorOptions = {
  white: {
    heading: 'var(--color-charcoal)',
    boxes1: 'var(--color-sand)',
    boxes1Text: 'var(--color-charcoal)',
    boxes2: 'var(--color-charcoal)',
    boxes2Text: 'var(--color-white)',
  },
  sand: {
    heading: 'var(--color-charcoal)',
    boxes1: 'var(--color-swiss-coffee)',
    boxes1Text: 'var(--color-charcoal)',
    boxes2: 'var(--color-charcoal)',
    boxes2Text: 'var(--color-white)',
  },
  charcoal: {
    heading: 'var(--color-white)',
    boxes1: 'var(--color-sand)',
    boxes1Text: 'var(--color-charcoal)',
    boxes2: 'var(--color-bark)',
    boxes2Text: 'var(--color-white)',
  },
  bark: {
    heading: 'var(--color-white)',
    boxes1: 'var(--color-sand)',
    boxes1Text: 'var(--color-charcoal)',
    boxes2: 'var(--color-charcoal)',
    boxes2Text: 'var(--color-white)',
  },
};

const StackedBoxesStyles = styled.section`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-flow: column wrap;
  padding: 2.2rem 0 5rem;
  text-align: center;
  background-color: var(--color-${({ bgColor }) => bgColor});

  > * {
    z-index: 1;
  }

  .bg {
    position: absolute;
    top: 0;
    left: 0;
    z-index: -1;
    width: 100%;
    height: 100%;
  }

  .heading {
    color: ${({ bgColor }) => colorOptions[bgColor].heading};
    font-weight: var(--font-weight-regular);
  }

  .boxes {
    display: grid;
    column-gap: 4rem;
    row-gap: 3.125rem;
    margin: 3.5rem 0 0;

    .box {
      display: flex;
      justify-content: center;
      flex-wrap: wrap;

      .box-inner {
        display: flex;
        flex-direction: column;
        width: 100%;
        padding: 3.125rem var(--grid-mobile-gutter);
        background-color: ${({ bgColor }) => colorOptions[bgColor].boxes1};

        .heading,
        .text {
          color: ${({ bgColor }) => colorOptions[bgColor].boxes1Text};
        }

        .heading {
          margin: 0 0 2.5rem;
          font-weight: var(--font-weight-medium);
        }

        .btn-group {
          margin-top: auto;
        }
      }

      &:first-child,
      &:nth-child(2) {
        .box-inner {
          background-color: ${({ bgColor }) => colorOptions[bgColor].boxes2};

          .heading,
          .text {
            color: ${({ bgColor }) => colorOptions[bgColor].boxes2Text};
          }
        }
      }
    }
  }

  @media (min-width: 768px) {
    padding: 4.2rem 0 10rem;
  }

  @media (min-width: 992px) {
    .boxes {
      grid-template-columns: 1fr 1fr;
      column-gap: 4rem;
      row-gap: 4rem;
      margin: 4.5rem auto 0;
      max-width: 90%;

      .box {
        .box-inner {
          padding: 4rem var(--grid-desktop-gutter);

          .heading {
            margin: 0 0 2.5rem;
          }

          .btn-group {
            padding: 4rem 0 0;
          }
        }
      }
    }
  }
`;

export default StackedBoxesStyles;
